import * as confirmAction from "../../../../store/confirm/action";
import * as loadingAction from "../../../../store/loading/action";
import * as messageAction from "../../../../store/message/action";

import { Col, Modal } from "reactstrap";
import {
  GET_DT_LINEPACK,
  GET_DT_LINEPACK_COLUMN,
  LOAD_DT_LINEPACK,
  SAVE_DT_LINEPACK,
  SAVE_DT_LINEPACK_COLUMN
} from "helpers/url_api_constant";
import PropTypes, { func } from "prop-types";
import React, { useEffect, useState } from "react";
import Select, { OptionProps, components } from "react-select";
import SelectColor, { colorOption } from "components/Custom/SelectColor";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";

import $ from "jquery";
import BootstrapTable from "react-bootstrap-table-next";
import Flatpickr from "react-flatpickr";
import OverButton from "../../../../components/Custom/Overbutton";
import { getPermission } from "../../../../helpers/auth_helper";
import moment from "moment";
import { post } from "helpers/api_helper";
import { useDispatch } from "react-redux";

function numberFormat(number, digit = 2) {
  if (number === null || number === "null" || number === "") return "";
  function isFloat(n) {
    return Number(n) === n && n % 1 !== 0;
  }
  if (isFloat(number)) return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
    minimumFractionDigits: digit,
  });
  return parseFloat(number).toLocaleString(undefined, {
    minimumFractionDigits: digit,
  });
}

function LinePack(props) {
  const dispatch = useDispatch();
  const permission = getPermission();
  const [AVGObject, setAVGObject] =useState({mode:"AVG",show_name:""});
  // console.log(permission);
  //   const [dateSelected, setDateSelected] = useState(props.dateSelected);
  const [dateNow, setDateNow] = useState(moment(new Date()).format("YYYY-MM"));
  const [showManageColumn, setShowManageColumn] = useState(false);
  const [columnDataList, setColumnDataList] = useState([]);
  const [columnManageList, setColumnManageList] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [modelDeviceList, setModelDeviceList] = useState([]);
  const [columnRenderList, setColumnRenderList] = useState([
    {
      dataField: "Dummy",
      text: "Date",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        backgroundColor: "#7E8EDA",
        width: "2%",
      },
      formatter: CountIndexRow,
    },
  ]);

  const rowStyle = (row, rowIndex) => {
    const style = {};
    if (
      rowIndex == modelDeviceList.length - 1 &&
      dateNow == moment(props.dateSelected).format("YYYY-MM")
    ) {
      style.fontWeight = "bold";
      style.color = "#FFFFFF";
      style.border = "2px solid #FFFFFF";
      // style.opacity = "0.6";
    } else {
      style.color = "white";
    }

    return style;
  };

  const rowStyleFontWhite = (row, rowIndex) => {
    const style = {};
    // style.fontWeight = 'bold';
    style.color = "white";

    return style;
  };

  const addHeaderTable = () => {
    let prevHeader = document.getElementById(
      "linepack-gas-volume-table-header"
    );
    prevHeader && prevHeader.remove();
    let thead = document
      .getElementById("linepack-tab-table")
      .getElementsByTagName("thead")[0];
    let tr = document.createElement("tr");
    tr.innerHTML =
      '<th id="linepack-gas-volume-table-header" colspan="' +
      (columnDataList.length + 2) +
      '" style="text-align:center;background-color:#556ee6;color:#FFFFFF">Line Pack</th>';
    thead.prepend(tr);
  };
  const getColumn = () => post(GET_DT_LINEPACK_COLUMN, {});
  const handleAddColumn = () => {
    setColumnManageList(prevent => [
      ...prevent,
      {
        ROW: columnManageList.length + 1,
        PID: "",
        LINEPACKCOLUMN_ORDER: columnManageList.length + 1,
        LINEPACKCOLUMN_NAME: "",
        SCADATAG_NAME: "",
        QTYPOINT_NAME: "",
        GMDRTAG_NAME: "",
        LINEPACKCOLUMN_DESC: "",
        LINEPACKCOLUMN_TYPE: "",
        LINEPACKCOLUMN_SHOW: true,
        PRIORITY_FLAG: 0,
        STATUS_FLAG: 0,
        color: colorOption[0],
        show: { label: "Show", value: 1 },
        source: { label: "Manual", value: 0 }
      },
    ]);
  };

  const handleSaveColumn = async () => {
    function validateDuplicate() {
      let valueArr = columnManageList.map(function (item) {
        return item.LINEPACKCOLUMN_NAME;
      });
      let isDuplicate = valueArr.some(function (item, idx) {
        return valueArr.indexOf(item) != idx;
      });
      return isDuplicate;
    }
    if (validateDuplicate()) {
      dispatch(messageAction.showMessage("Column name is duplicate."));
      throw "exit";
    }
    dispatch(loadingAction.showLoading());
    try {
      if (
        !columnManageList.some(
          row => row.LINEPACKCOLUMN_NAME == "" || row.LINEPACKCOLUMN_ORDER == ""
        )
      ) {
        let data = [...columnManageList];
        let res = await post(SAVE_DT_LINEPACK_COLUMN, data);
        if (res.resultCode == 200) {
          fetchData();
          setShowManageColumn(false);
          dispatch(messageAction.showMessage("Save success."));
        }
      } else {
        dispatch(messageAction.showMessage("Plesae key in."));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  const generateRow = () => {
    function addDays(date, days) {
      var result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    }
    function getDaysInMonth(month, year) {
      var date = new Date(year, month, 1);
      var days = [];
      while (date.getMonth() === month) {
        days.push({
          date: new Date(date),
          LINEPACK_DATE: moment(new Date(date)).format("YYYY-MM-DD"),
          LINEPACK_DAY: new Date(date).getDate(),
        });
        date.setDate(date.getDate() + 1);
      }
      return days;
    }
    let currentDate = addDays(new Date(), -1);
    let startDate = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1
    );
    let dayList;
    let dateDiff = currentDate.getDate() - startDate.getDate() + 1;

    if (
      props.dateSelected &&
      (props.dateSelected.getFullYear() < currentDate.getFullYear() || (props.dateSelected.getMonth() < currentDate.getMonth() && props.dateSelected.getFullYear() == currentDate.getFullYear()))
    ) {
      dayList = getDaysInMonth(
        props.dateSelected.getMonth(),
        props.dateSelected.getFullYear()
      );
    } else {
      dayList = getDaysInMonth(
        currentDate.getMonth(),
        currentDate.getFullYear()
      );
      dayList = dayList.slice(0, dateDiff);
    }
    dayList = addFieldToModelDeviceList(dayList);
    setModelDeviceList(dayList);
  };
  const ButtonAction = (cellContent, row) => {
    return (
      <div>
        {permission.eGLP && (
          <>
            <button
              type="button"
              className="btn btn-sm btn-secondary"
              // onClick={() => { refreshData(row) }}
              onClick={() => {
                dispatch(
                  confirmAction.showConfirm(
                    "ต้องการ Refresh หรือไม่ ? หากต้องการ Refresh ระบบจะทำการล้างค่าปัจจุบัน",
                    () => {
                      refreshData(row)
                    }
                  )
                );
              }}
            >
              Refresh
            </button>
            <button
              type="button"
              className="btn btn-sm btn-success ms-1"
              onClick={() => {
                handleSaveDataByRow(row);
              }}
            >
              Save
            </button>
          </>
        )}
      </div>
    );
  };
  const formatNumber = (cellContent, row) => {
    return (
      <div>
        {numberFormat(cellContent, 2)}
      </div>
    );
  };
  const renderColumn = () => {
    // console.log(columnDataList)
    setColumnRenderList([
      {
        dataField: "Dummy",
        text: "Date",
        headerAlign: "center",
        editable: false,
        align: "center",
        headerStyle: {
          backgroundColor: "#556ee6",
          width: "30px",
          fontSize: "11px"
        },
        style: { width: "30px", },
        formatter: CountIndexRow,
      },
      ...columnDataList
        .sort((a, b) =>
          a.LINEPACKCOLUMN_ORDER > b.LINEPACKCOLUMN_ORDER
            ? 1
            : b.LINEPACKCOLUMN_ORDER > a.LINEPACKCOLUMN_ORDER
              ? -1
              : 0
        )
        .filter(
          obj =>
            obj.LINEPACKCOLUMN_SHOW == true || obj.LINEPACKCOLUMN_SHOW == "true"
        )
        .map(obj => ({
          dataField: obj.LINEPACKCOLUMN_NAME.replaceAll(".", "_"),
          text: obj.LINEPACKCOLUMN_NAME,
          headerAlign: "center",
          editable: true,
          align: "center",
          editorStyle: () => {
            return { height: "25px" }
          },
          headerStyle: {
            backgroundColor: colorOption[obj.LINEPACKCOLUMN_TYPE].label,
            // width: "70px",
            fontSize: "11px"
          },
          formatter: formatNumber,
          style: { width: "70px",cursor:"pointer" },
          classes: (cell, row, rowIndex, colIndex) => {
            let className = "";
            if (obj.STATUS_FLAG != 0) className += "from-source";
            if (obj.STATUS_FLAG == 1)
              className += " pmis";
            if (obj.STATUS_FLAG == 3)
              className += " gqms";
            return className;
          },
          validator: (newValue, row, column, done) => {
            setTimeout(() => {
              if (isNaN(newValue)) {
                return done({
                  valid: false,
                  message: "Should be numeric",
                });
              }
              return done();
            }, 0);
            return {
              async: true,
            };
          },
        })),
      {
        dataField: "Action",
        text: "Action",
        headerAlign: "center",
        editable: false,
        align: "center",
        headerStyle: {
          backgroundColor: "#556ee6",
          width: "120px",
          fontSize: "11px"
        },
        style: { width: "120px" },
        formatter: ButtonAction,
      },
    ]);
  };
  const refreshData = async (row) => {
    // console.log(row)
    dispatch(loadingAction.showLoading());
    try {
      let refresh = await post(LOAD_DT_LINEPACK, { GAS_DATE: row.LINEPACK_DATE })
      if (refresh.resultCode == 200) {
        dispatch(messageAction.showMessage("Refresh success."));
        fetchData()
      } else {
        dispatch(messageAction.showMessage(refresh.resultDescription));

      }



    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  }
  const handleShowManageColumn = async () => {
    setColumnManageList([]);
    dispatch(loadingAction.showLoading());
    try {
      setShowManageColumn(true);
      let column = await getColumn();
      // console.log(column);
      setColumnManageList(
        column.data.dtLinePackColumnList.map((obj, index) => ({
          ...obj,
          ROW: index + 1,
          color: colorOption[obj.LINEPACKCOLUMN_TYPE],
          show: obj.LINEPACKCOLUMN_SHOW == 1 ? { label: "Show", value: 1 } : { label: "Hide", value: 0 },
          source: obj.STATUS_FLAG == 0 ? { label: "Manual", value: 0 } : obj.STATUS_FLAG == 1 ? { label: "Scada", value: 1 } : obj.STATUS_FLAG == 3 ? { label: "GQMS", value: 3 } : { label: "Flow Selection", value: 2 }
        }))
      );
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }

    dispatch(loadingAction.hideLoading());
  };
  const handleSaveData = async () => {
    dispatch(loadingAction.showLoading());
    try {
      let data = [];
      modelDeviceList.map(obj => {
        columnDataList.map(objColumn => {
          data.push({
            ...obj[
            `${objColumn.LINEPACKCOLUMN_NAME.replaceAll(".", "_")}__data`
            ],
            LINEPACK_DATA:
              obj[objColumn.LINEPACKCOLUMN_NAME.replaceAll(".", "_")],
          });
        });
      });
      let res = await post(SAVE_DT_LINEPACK, data);
      if (res.resultCode == 200) {
        dispatch(messageAction.showMessage("Save success."));
        fetchData();
      } else {
        dispatch(messageAction.showMessage(res.resultDescription));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  const handleSaveDataByRow = async row => {
    dispatch(loadingAction.showLoading());
    try {
      let data = [];
      columnDataList.map(objColumn => {
        data.push({
          ...row[`${objColumn.LINEPACKCOLUMN_NAME.replaceAll(".", "_")}__data`],
          LINEPACK_DATA:
            row[objColumn.LINEPACKCOLUMN_NAME.replaceAll(".", "_")],
        });
      });
      let res = await post(SAVE_DT_LINEPACK, data);
      if (res.resultCode == 200) {
        dispatch(messageAction.showMessage("Save success."));
        // fetchData()
      } else {
        dispatch(messageAction.showMessage(res.resultDescription));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  const fetchData = async () => {
    dispatch(loadingAction.showLoading());

    try {
      // generateRow();
      let column = await getColumn();
      setColumnDataList(
        column.data.dtLinePackColumnList.map((obj, index) => ({
          ...obj,
          ROW: index + 1,
        }))
      );
      let data = await post(GET_DT_LINEPACK, {
        LINEPACK_MONTHYEAR: moment(props.dateSelected).format("YYYY-MM-01"),
      });
      setDataList(data.data.dtLinePackList);
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  useEffect(() => {
    //fixed header table
    let tableId = "linepack-tab-table";
    let scrollY = 195;
    function fixedTableHeader() {
      let headerTable = document.querySelector(`#${tableId} thead`);
      if (window.scrollY >= scrollY) {
        headerTable.classList.add("fixed-header");

        resizeTableHeader()
      } else {
        headerTable.classList.remove("fixed-header");
      }
    }
    function resizeTableHeader() {
      setTimeout(() => {
        let headerTable = document.querySelector(`#${tableId} thead`);
        let tr = document.querySelector(`#${tableId} tbody tr`);
        let th = headerTable.querySelector(".header-style");
        for (var i = 0; i < tr.childNodes.length; i++) {
          th.childNodes[i].style.width = `${tr.childNodes[i].offsetWidth}px`;
        }
      }, 1);
    }
    window.addEventListener("scroll", fixedTableHeader);
    document.querySelector(`#vertical-menu-btn`).addEventListener("click", resizeTableHeader)
    return () => {
      window.removeEventListener("scroll", fixedTableHeader);
      document.querySelector(`#vertical-menu-btn`)?.removeEventListener("click", resizeTableHeader);
    };
    //fixed header table
  }, []);
  useEffect(() => {
    generateRow();
  }, [dataList]);
  useEffect(() => {
    fetchData();
  }, [props.dateSelected]);
  useEffect(() => {
    renderColumn();
    addHeaderTable();
    // if (columnDataList.length > 1) {
    //   generateRow();
    // }
  }, [columnDataList]);
  useEffect(() => {
    let data = [];
    modelDeviceList.map(obj => {
      columnDataList.map(objColumn => {
        if (
          obj[`${objColumn.LINEPACKCOLUMN_NAME.replaceAll(".", "_")}__data`]
            .PID == ""
        ) {
          data.push({
            ...obj[
            `${objColumn.LINEPACKCOLUMN_NAME.replaceAll(".", "_")}__data`
            ],
            LINEPACK_DATA:
              obj[objColumn.LINEPACKCOLUMN_NAME.replaceAll(".", "_")],
          });
        }
      });
    });
    if (data.length > 0) {
      // console.log('test')
        intialSave(data);
    }
  }, [modelDeviceList]);
  const intialSave = async data => {
    if(permission.eGLP ){
    dispatch(loadingAction.showLoading());
    try {
      let res = await post(SAVE_DT_LINEPACK, data);
      if (res.resultCode == 200) {
        // dispatch(messageAction.showMessage("Save success."));
        fetchData();
      } else {
        dispatch(messageAction.showMessage(res.resultDescription));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
    }
  };

  const calculateAVG = () => {
    let planAvg =
      modelDeviceList.reduce(
        (a, b) => a + parseFloat(b.LINEPACK_DATA),
        0
      ) / modelDeviceList.length;
    let avgObj = { mode:"AVG",date: "AVG", LINEPACK_DATA: planAvg };
    columnDataList.map(collumn => {
      let sum = 0;
      modelDeviceList.map(object => {
        sum += object[collumn.LINEPACKCOLUMN_NAME];
      });
      avgObj[collumn.LINEPACKCOLUMN_NAME] = sum / modelDeviceList.length;
    });
    setAVGObject(avgObj);
  };

  useEffect(() => {
    calculateAVG();
  }, [modelDeviceList]);

  const addFieldToModelDeviceList = rowList => {
    let dataModel = {
      PID: "",
      LINEPACK_DATE: "",
      LINEPACKCOLUMN_PID: "",
      LINEPACKCOLUMN_ORDER: 0,
      LINEPACKCOLUMN_NAME: "",
      LINEPACK_DAY: 0,
      LINEPACK_DATA: 0,
      SOURCE_PID: null,
      SOURCE_NAME: null,
      PRIORITY_FLAG: 0,
      STATUS_FLAG: 0,
    };
    if (rowList.length > 0) {
      let data = dataList;
      let modelList = [];
      columnDataList.map(objColumn => {
        modelList = rowList.map(obj => {
          let value = data.find(
            value =>
              value.LINEPACKCOLUMN_PID == objColumn.PID &&
              value.LINEPACK_DAY == obj.LINEPACK_DAY
          );
          obj[objColumn.LINEPACKCOLUMN_NAME.replaceAll(".", "_")] = value
            ? value.LINEPACK_DATA
            : 0;
          obj[`${objColumn.LINEPACKCOLUMN_NAME.replaceAll(".", "_")}__data`] = {
            ...dataModel,
            ...value,
            LINEPACK_DATE: obj.LINEPACK_DATE,
            LINEPACK_DAY: obj.LINEPACK_DAY,
            LINEPACKCOLUMN_PID: objColumn.PID,
            LINEPACKCOLUMN_ORDER: objColumn.LINEPACKCOLUMN_ORDER,
            LINEPACKCOLUMN_NAME: objColumn.LINEPACKCOLUMN_NAME,
          };
          return { ...obj };
        });
      });
      return modelList;
    }
  };
  const PickColor = (cellContent, row) => {
    return (
      <SelectColor
        value={cellContent}
        onChange={selected => {
          setColumnManageList(prev => {
            return prev.map(obj => {
              if (row.ROW == obj.ROW) {
                return {
                  ...obj,
                  color: selected,
                  LINEPACKCOLUMN_TYPE: selected.value,
                };
              }
              return { ...obj };
            });
          });
        }}
      />
    );
  };

  const SelectStyle = {
    option: (provided, { data, isDisabled, isFocused, isSelected }) => ({
      ...provided,
      ...isFocused && ({ backgroundColor: '#2E3460' })
    }),
  }
  const SelectShow = (cellContent, row) => {
    return (
      <Select
        value={cellContent}
        options={[
          { label: "Show", value: 1 },
          { label: "Hide", value: 0 },
        ]}
        classNamePrefix="select2-selection"
        styles={SelectStyle}
        onChange={selected => {
          setColumnManageList(prev => {
            return prev.map(obj => {
              if (row.ROW == obj.ROW) {
                return {
                  ...obj,
                  show: selected,
                  LINEPACKCOLUMN_SHOW: selected.value,
                };
              }
              return { ...obj };
            });
          });
        }}
      />
    );
  };
  const SelectSource = (cellContent, row) => {
    return (
      <Select
        value={cellContent}
        options={[
          { label: "Manual", value: 0 },
          { label: "Scada", value: 1 },
          // { label: "Flow Selection", value: 2 },
          // { label: "GQMS", value: 3 },
        ]}
        classNamePrefix="select2-selection"
        onChange={selected => {
          setColumnManageList(prev => {
            return prev.map(obj => {
              if (row.ROW == obj.ROW) {
                return {
                  ...obj,
                  source: selected,
                  STATUS_FLAG: selected.value,
                };
              }
              return { ...obj };
            });
          });
        }}
      />
    );
  };
  const columnManage = [
    {
      dataField: "LINEPACKCOLUMN_ORDER",
      text: "Order",
      headerAlign: "center",
      sort: true,
      editable: true,
      align: "center",
      style: {
        width: "50px",
        cursor:"pointer",
      },
      type: "number",
    },

    {
      dataField: "LINEPACKCOLUMN_NAME",
      text: "Column Name",
      headerAlign: "center",
      sort: true,
      editable: (content, row, rowIndex, columnIndex) => row.PID == "",
      align: "center",
      style: {
        width: "100px",
      },
    },
    {
      dataField: "source",
      text: "Source",
      headerAlign: "center",
      sort: true,
      editable: false,
      align: "center",
      style: {
        width: "125px",
      },
      sortFunc: (a, b, order, dataField) => {
        if (order === 'asc') {
          return b.value - a.value;
        }
        return a.value - b.value; // desc
      },
      formatter: SelectSource
    },
    // {
    //   dataField: "GMDRTAG_NAME",
    //   text: "GQMS Tag",
    //   headerAlign: "center",
    //   sort: true,
    //   editable: true,
    //   align: "center",
    //   style: {
    //     width: "150px",
    //     cursor:"pointer",
    //   },
    // },
    {
      dataField: "SCADATAG_NAME",
      text: "SCADA Tag",
      headerAlign: "center",
      sort: true,
      editable: true,
      align: "center",
      style: {
        width: "150px",
        cursor:"pointer",
      },
    },

    // {
    //   dataField: "QTYPOINT_NAME",
    //   text: "Quality Point",
    //   headerAlign: "center",
    //   sort: true,
    //   editable: true,
    //   align: "center",
    //   style: {
    //     width: "100px",
    //   },
    // },

    // {
    //   dataField: "LINEPACKCOLUMN_DESC",
    //   text: "Description",
    //   headerAlign: "center",
    //   sort: true,
    //   editable: true,
    //   align: "center",
    //   style: {
    //     width: "150px",
    //   },
    // },
    {
      dataField: "color",
      text: "Color",
      headerAlign: "center",
      sort: true,
      editable: false,
      align: "center",
      style: {
        width: "70px",
      },
      sortFunc: (a, b, order, dataField) => {
        if (order === 'asc') {
          return b.value - a.value;
        }
        return a.value - b.value; // desc
      },
      formatter: PickColor,

    },
    {
      dataField: "show",
      text: "Status",
      headerAlign: "center",
      sort: true,
      editable: false,
      align: "center",
      style: {
        width: "100px",
      },
      sortFunc: (a, b, order, dataField) => {
        if (order === 'asc') {
          return b.value - a.value;
        }
        return a.value - b.value; // desc
      },
      formatter: SelectShow
    },
    // {
    //   dataField: "ACTION",
    //   isDummyField: true,
    //   text: "Action",
    //   headerAlign: "center",
    //   align: "center",
    //   style: {
    //     width: "150px",
    //   },
    //   formatter: deleteColumnButton,
    // },
  ];
  return (
    <div>
      <Col sm="12">
        <div className="d-flex justify-content-end">
          {permission.mMIM && (
            <button
              type="button"
              className="btn btn-primary me-2"
              onClick={() => handleShowManageColumn()}
            >
              <i className="bx bx-columns"></i>&nbsp; Manage Column Line Pack
            </button>
          )}
          {/* <button
            type="button"
            className="btn btn-success me-2"
            onClick={handleSaveData}
          >
            <i className="bx bx-save"></i>&nbsp; Save
          </button> */}
        </div>
        <div className="mt-2">
          <BootstrapTable
            id="linepack-tab-table"
            keyField="date"
            data={modelDeviceList}
            columns={columnRenderList}
            rowStyle={rowStyle}
            headerClasses="header-style"
            cellEdit={cellEditFactory({
              mode: "click",
              blurToSave: true,
              onStartEdit: (oldValue, newValue, row, column) => {
                $("#linepack-tab-table .form-control.editor.edit-text").bind(
                  "enterKey",
                  function (e) {
                    let cell = $(this).parent().next();
                    setTimeout(() => {
                      cell.click();
                    }, 50);
                  }
                );
                $(
                  "#linepack-tab-table .form-control.editor.edit-text"
                ).keypress(function (e) {
                  if (e.keyCode == 13) {
                    $(this).trigger("enterKey");
                  }
                });
              },
              afterSaveCell: (oldValue, newValue, row, column) => {
                calculateAVG();
                // console.log(column);
              },
            })}
          />
            <BootstrapTable
              id="linepack-tab-avg-table"
              keyField="mode"
              data={[AVGObject]}
              columns={[
                {
                  dataField: "mode",
                  text: "",
                  headerAlign: "center",
                  editable: false,
                  align: "center",
                  headerStyle: {
                    backgroundColor: "#7E8EDA",
                    width: "30px",
                  },
                  style: { width: "30px" },
                },
                ...columnRenderList.filter((row, index) => index != 0 && index != columnRenderList.length-1),
                {
                  dataField: "show_name",
                  text: "",
                  headerAlign: "center",
                  editable: false,
                  align: "center",
                  headerStyle: {
                    backgroundColor: "#7E8EDA",
                    width: "115px",
                  },
                  style: { width: "115px" },
                },
              ]}
              rowStyle={rowStyle}
              wrapperClasses={"hidden-column mt-4"}
              headerClasses="header-style hide"
            />
        </div>
      </Col>
      <Modal size="xl" isOpen={showManageColumn} backdrop={"static"} style={{ maxWidth: "70%" }}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Manage Line Pack</h5>

          <button
            type="button"
            onClick={() => {
              setShowManageColumn(false);
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <BootstrapTable
            id="collumn-linepack-table"
            keyField="ROW"
            data={columnManageList}
            columns={columnManage}
            rowStyle={rowStyleFontWhite}
            headerClasses="header-style"
            defaultSorted={defaultSortColumnManage}
            cellEdit={cellEditFactory({
              mode: "click",
              blurToSave: true,
              afterSaveCell: (oldValue, newValue, row, column) => {
                // console.log(columnDataList);
              },
            })}
          />
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => handleAddColumn()}
            >
              <i className="bx bx-plus"></i>&nbsp; Add
            </button>

            <button
              type="button"
              className="btn btn-success"
              onClick={() => handleSaveColumn()}
            >
              <i className="bx bx-save"></i>&nbsp; Save
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setShowManageColumn(false)}
            >
              Close
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
const defaultSortColumnManage = [
  {
    dataField: "LINEPACKCOLUMN_ORDER",
    order: "asc", // or desc
  },
];
export default LinePack;

const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;

//headerColumn
const deleteColumnButton = (cell, row) => (
  <OverButton
    onClick={() => {
      // onDelete(row);
    }}
    color="danger"
    icon="fas fa-trash-alt"
    label="Delete"
  />
);

LinePack.propTypes = {
  dateSelected: PropTypes.any,
};
